module.exports = __webpack_public_path__ + "img/green_wave@2x.fbb7c836.png";